import { render } from "./graphic.vue?vue&type=template&id=022655b8&scoped=true"
import script from "./graphic.vue?vue&type=script&lang=js"
export * from "./graphic.vue?vue&type=script&lang=js"

import "./graphic.vue?vue&type=style&index=0&id=022655b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022655b8"]])

export default __exports__